import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Check, ChevronDown } from "lucide-react";

const MultiSelectDropDown = ({
  label,
  id,
  values = [],
  onChange,
  options = [],
  placeholder = "Select options...",
  className = "",
  labelClassName = "",
  disabled = false,
  error = "",
}) => {
  const [selectedValues, setSelectedValues] = useState(values);
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (selectedValue) => {
    let updatedValues;
    if (selectedValues.includes(selectedValue)) {
      updatedValues = selectedValues.filter((val) => val !== selectedValue);
    } else {
      updatedValues = [...selectedValues, selectedValue];
    }
    setSelectedValues(updatedValues);
    onChange(updatedValues);
  };

  return (
    <div className="w-full flex flex-col gap-1">
      {label && (
        <label
          htmlFor={id}
          className={`text-body1 font-ptsans text-secondary/90  font-medium pl-2 block${labelClassName}`}
        >
          {label}
        </label>
      )}

      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger
          disabled={disabled}
          className={`flex h-12 w-full items-center grow-0 shrink-0  justify-between rounded-xl border-2 text-secondary/80 border-secondary/40 data-[placeholder]:text-secondary/60 bg-transparent px-3 py-2 text-body1 ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-secondary/30 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1${className}`}
        >
          <span className="w-full text-start text-secondary/80 line-clamp-1">
            {selectedValues.length > 0
              ? options
                  .filter((opt) => selectedValues.includes(opt.value))
                  .map((opt) => opt.label)
                  .join(", ")
              : placeholder}
          </span>
          <ChevronDown className="w-4 h-4 text-secondary/60 grow-0 shrink-0" />
        </PopoverTrigger>

        <PopoverContent className="lg:!min-w-[20rem] md:!min-w-[16rem] !min-w-[12rem]">
          <div className="flex flex-col py-1">
            {options.map((option) => {
              const isSelected = selectedValues.includes(option.value);
              return (
                <div
                  key={option.value}
                  onClick={() => handleSelect(option.value)}
                  className={`flex justify-between items-center px-4 py-2 cursor-pointer hover:bg-background_2 transition-colors ${
                    isSelected ? "bg-background_2" : ""
                  }`}
                >
                  <span className="">{option.label}</span>
                  {isSelected && <Check className="w-4 h-4 " />}
                </div>
              );
            })}
          </div>
        </PopoverContent>
      </Popover>

      {error && (
        <span className="text-caption text-red-500 font-ptsans pl-2">
          {error}
        </span>
      )}
    </div>
  );
};

export default MultiSelectDropDown;
